import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { withRouter } from "react-router";
import { useLocation } from "react-router-dom";
import CardAds from "../Card/CardAds";
import CardEvents from "../Card/CardEvents";
import "../css/Events.css";
import CallCenter from "../EventComponent/CallCenter/CallCenter";
import CardPrograms from "../EventComponent/CardPrograms/CardPrograms";
import DesktopLeft from "../EventComponent/DesktopLeft";
import DesktopRight from "../EventComponent/DesktopRight";
import "../EventComponent/FillProfile/FillProfile.css";
import FillQna from "../EventComponent/FillQna/FillQna";
import MaterialEvents from "../EventComponent/MaterialEvents";
import MobileHeader from "../EventComponent/MobileHeader";
import MobileHome from "../EventComponent/MobileHome";
import { PremiumDialog } from "../EventComponent/PremiumDialog/PremiumDialog";
import QnaHome from "../EventComponent/QnaHome";
import WebinarTanyaAhli from "../EventComponent/TanyaAhli/WebinarTanyaAhli";
import PopupAudioEvent from "../Popup/PopupAudioEvent";
import PopupAuthEvent from "../Popup/PopupAuthEvent";
import PopupTesti from "../Popup/PopupTesti/PopupTesti";
import { logAdvertising } from "../services/ads";
import { getPijarUser } from "../services/auth";
import { getPrograms } from "../services/packages";
import { AskQuestionContainer } from "./AskQuestionContainer";
import Loading from "./Loading";

function WebinarHome(props) {
  const eventCode = props.match.params.event_code ?? props.eventCode;
  localStorage.setItem("eventCode", eventCode);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const names = localStorage.getItem("name");
  const [memberType, setMembertype] = useState(undefined);
  const [tenants, setTenants] = useState(null);
  const [activePackages, setActivePackages] = useState(null);
  const [eventData, setEventData] = useState({});
  const [material, setMaterial] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [qna, setQna] = useState([]);
  const [openTesti, setOpenTesti] = useState(false);
  const [testimoniItem, setTestimoniItem] = useState({
    name: "",
    scheduleId: "",
    score: 0,
    memberId: token ?? "",
    reason: "",
  });
  const [maindata, setMaindata] = useState({});
  const [titleAudio, setTitleAudio] = useState("");
  const [audioId, setAudioId] = useState(null);
  const [idl, setIdl] = useState(0);
  const [testimonLoading, setTestiLoading] = useState(false);
  const [dataLeftAds, setLeftAds] = useState([]);
  const [dataRightAds, setRightAds] = useState([]);
  const [dataFloatingAds, setFloatingAds] = useState([]);
  const [question, setQuestion] = useState({});
  const [isQuestionSubmitted, setIsQuestionSubmitted] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [lengthQuiz, setLengthQuiz] = useState(0);
  const [askQuestion, setAskQuestion] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [programs, setPrograms] = useState([]);
  const [profile, setProfile] = useState({});
  const [profileMember, setProfileMember] = useState({});
  const [premiumDialog, setPremiumDialog] = useState(false);
  const [expired, setExpired] = useState(false);
  const [speaker, setSpeaker] = useState({});
  const [isValid, setIsValid] = useState(true);
  const [isWAEmpty, setIsWAEmpty] = useState(false);
  const [askExpert, setAskExpert] = useState(undefined);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const userId = useQuery().get("userId");

  const getSchedules = async (events) => {
    let payload = {};

    if (token !== "" || token !== null) {
      payload = {
        tenantId: events.tenantId,
        token: token,
      };
    }

    await axios
      .post(
        process.env.REACT_APP_FETCH_URL + "/schedule/" + events.eventId,
        payload
      )
      .then(async (res) => {
        if (res?.data) {
          setSchedule(res?.data);

          const materials = await axios.get(
            process.env.REACT_APP_FETCH_URL +
              "/event_materials/" +
              events.eventId
          );

          setMaterial(materials?.data);

          let url =
            process.env.REACT_APP_FETCH_URL +
            "/audio_typeform_event/" +
            events.eventId;

          if (token) {
            url += "/" + token;
          }

          const homeAudio = await axios.get(url);

          setQna(homeAudio?.data);
          setMaindata({
            ...maindata,
            schedule: res?.data,
            qna: homeAudio?.data,
          });

          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    if (!eventData?.eventId) {
      return;
    }

    if (userId) {
      getPijarUser({
        userId: userId,
        tenantId: eventData.tenantId,
      });
    }

    getAdvertising("left-sidebar");
    getAdvertising("right-sidebar");
    if (isMobile) {
      getAdvertising("mobile-floating");
    }

    getPrograms(eventData.eventId, token).then((d) => {
      setPrograms(d?.data);
    });
  }, [eventData]);

  useEffect(() => {
    if (!token || !askExpert) {
      return;
    }
    
    setPremiumDialog(false);

    if (askExpert === "available" || eventData?.isPremium === "true") {
      setMembertype("payforMicrosite");
    }

    if (eventData?.isPaid === "true" && memberType && memberType !== "payforMicrosite") {
      setExpired(true);
      setPremiumDialog(true);
    }

    if (eventData?.isPaid !== "true" && memberType && memberType !== "payforMicrosite") {
      setExpired(false);
      setPremiumDialog(true);
    }
  }, [eventData, memberType, askExpert]);

  const getAdvertising = async (mode = "left-sidebar") => {
    let payload = {};
    let placement = window.location.pathname.slice(
      1,
      window.location.pathname.length
    );

    payload = {
      placement,
      tenantId: "",
      eventId: eventData.eventId,
      scheduleId: "",
      adsType: mode,
    };

    await axios
      .post(process.env.REACT_APP_FETCH_URL + "/advertising", payload)
      .then(async (res) => {
        if (res?.data) {
          logAdvertising("loaded", mode, res?.data[0]?.adsId);

          if (mode === "left-sidebar") {
            setLeftAds(res?.data);
          }
          if (mode === "right-sidebar") {
            setRightAds(res?.data);
          }
          if (mode === "mobile-floating") {
            setFloatingAds(res?.data);
          }
        }
      });
  };

  useEffect(() => {
    async function checkEvent() {
      await axios
        .get(process.env.REACT_APP_FETCH_URL + "/events/" + eventCode)
        .then((res) => {
          if (res?.data) {
            setIsLoading(false);
            setEventData(res?.data);
            getSchedules(res?.data);

            localStorage.setItem("a01c12", res?.data?.tenantId);

            if (res?.data.quizId !== "" || res?.data.quizId !== "null") {
              setLengthQuiz(parseInt(res?.data.quizId));
            }
          }
        });

      if (!token) {
        return;
      }

      const url = localStorage.getItem("a01c12")
        ? "/members/" +
          token +
          "/" +
          localStorage.getItem("a01c12") +
          "/mcs/tenants"
        : "/members/" + token;

      await axios.get(process.env.REACT_APP_FETCH_URL + url).then((result) => {
        if (result?.data?.payforMicrosite === "true") {
          setMembertype("payforMicrosite");
        } else {
          setMembertype("non-member");
        }

        setTenants(result?.data?.tenants);
        setActivePackages(result?.data?.activePackages);
        setUserEmail(result?.data?.email);
      });

      await axios
        .get(process.env.REACT_APP_FETCH_URL + `/profile/${token}`)
        .then((res) => {
          const profileJson = res?.data[0]?.profileData
            ? JSON.parse(res?.data[0]?.profileData)
            : {};

          setProfileMember(profileJson);
          setProfile(profileJson);
        });
    }
    checkEvent();
  }, [token, eventCode]);
  const gotoTypeForm = React.useCallback(() => {
    if (token === null) {
      setOpenLogin(true);
      return;
    }

    if (expired) {
      return setPremiumDialog(true);
    }

    setAskQuestion(true);
  }, [eventData]);
  const sendTesti = async () => {
    if (!token || token === null) {
      setOpenLogin(true);
      return;
    }
    setTestiLoading(true);
    delete testimoniItem?.name;
    const url = process.env.REACT_APP_FETCH_URL + "/set-feedback-schedule";
    testimoniItem.score = parseInt(testimoniItem.score);
    const { data } = await axios.post(url, testimoniItem);
    if (!data) {
      alert("Terjadi Kesalahan");
      return;
    }

    setOpenTesti(false);
    setTestiLoading(false);
    setTestimoniItem({});
    setSchedule([]);

    getSchedules({
      eventId: eventData.eventId,
      tenantId: eventData.tenantId,
    });
    return;
  };

  useEffect(() => {
    if (openLogin) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [openLogin]);

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <MobileHeader
            tenants={tenants}
            activePackages={activePackages}
            eventCode={eventCode}
            token={token}
            setOpenLogin={setOpenLogin}
            names={names}
            memberType={memberType}
            email={userEmail}
            eventData={eventData}
            setPremiumDialog={setPremiumDialog}
            expired={expired}
            setExpired={setExpired}
          />
          <div className="parent-event">
            <div className="event-container">
              <MobileHome
                eventData={eventData}
                token={token}
                eventCode={eventCode}
                setOpenLogin={setOpenLogin}
                material={material}
                schedule={schedule}
                setOpenTesti={setOpenTesti}
                setTestimoniItem={setTestimoniItem}
                lengthQuiz={lengthQuiz}
                testimoniItem={testimoniItem}
                qna={qna}
                setQna={setQna}
                maindata={maindata}
                setTitleAudio={setTitleAudio}
                setAudioId={setAudioId}
                setIdl={setIdl}
                adsData={dataRightAds?.[0]}
                dataFloatingAds={dataFloatingAds?.[0]}
                programs={programs[programs.length - 1]}
                isMobile={isMobile}
                expired={expired}
                memberType={memberType}
                name={names}
                setAskQuestion={setAskQuestion}
                setSpeaker={setSpeaker}
                setAskExpert={setAskExpert}
              />
              <DesktopLeft
                expired={expired}
                getAdvertisingLog={undefined}
                eventData={eventData}
                dataAds={dataLeftAds?.[0]}
                token={token}
                setIdl={setIdl}
                setOpenLogin={setOpenLogin}
                names={names}
                memberType={memberType}
                email={userEmail}
                tenants={tenants}
                visibleAds={true}
                activePackages={activePackages}
                eventCode={eventCode}
                setExpired={setExpired}
              />
              <DesktopRight
                expired={expired}
                activeTabs={0}
                token={token}
                setOpenLogin={setOpenLogin}
                eventCode={eventCode}
                eventData={eventData}
                gotoTypeForm={gotoTypeForm}
                profileName={names}
                profileEmail={userEmail}
                memberType={memberType}
                setExpired={setExpired}
                activePackages={activePackages}
                leftChildren={
                  <React.Fragment>
                    <WebinarTanyaAhli
                      eventData={eventData}
                      name={names}
                      setAskQuestion={setAskQuestion}
                      setSpeaker={setSpeaker}
                      setOpenLogin={setOpenLogin}
                      setAskExpert={setAskExpert}
                      setPremiumDialog={setPremiumDialog}
                    />
                    {qna.length > 0 && (
                      <QnaHome
                        expired={expired}
                        maindata={maindata}
                        setQna={setQna}
                        setTitleAudio={setTitleAudio}
                        setAudioId={setAudioId}
                        setOpenLogin={setOpenLogin}
                        token={token}
                        eventCode={eventCode}
                        qna={qna}
                        eventData={eventData}
                        setPremiumDialog={setPremiumDialog}
                      />
                    )}
                    {programs?.length > 0 && (
                      <div className="last-event">
                        <div className="head-section">
                          <h1>{t("practical-module")}</h1>
                          <button
                            onClick={() => {
                              if (token && token !== null) {
                                if (eventData?.isPaid !== "true" && memberType && memberType !== "payforMicrosite") {
                                  setExpired(false);
                                  return setPremiumDialog(true);
                                } 
                                if (expired) return setPremiumDialog(true);

                                props.history.push(`/e/${eventCode}/programs`);
                                return;
                              }
                              setOpenLogin(true);
                            }}
                            className="look-all"
                          >
                            {t("see-all")}
                          </button>
                        </div>

                        <CardPrograms
                          programs={programs[0]}
                          materi={true}
                          eventData={eventData}
                          setPremiumDialog={setPremiumDialog}
                          expired={expired}
                          memberType={memberType}
                          setExpired={setExpired}
                        />
                      </div>
                    )}
                    <div className="materials-desktop">
                      {material?.length || lengthQuiz > 0 ? (
                        <MaterialEvents
                          length={material?.length}
                          push={() => {
                            props.history.push(
                              `/e/${eventCode}/materials_event`
                            );
                          }}
                          pushQuiz={() => {
                            props.history.push(`/e/${eventCode}/quiz`);
                          }}
                          setOpenLogin={setOpenLogin}
                          lengthQuiz={lengthQuiz}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {schedule?.length > 0 && (
                      <div className="last-event">
                        <div className="head-section">
                          <h1>{t("upcoming-webinar")}</h1>
                          <button
                            onClick={() => {
                              if (token && token !== null) {
                                props.history.push(`/e/${eventCode}/schedule`);
                                return;
                              }
                              setOpenLogin(true);
                            }}
                            className="look-all"
                          >
                            {t("see-all")}
                          </button>
                        </div>
                        {schedule
                          ?.slice(schedule?.length - 1, schedule?.length)
                          ?.map((item, index) => (
                            <CardEvents
                              eventCode={eventCode}
                              setOpenLogin={setOpenLogin}
                              setOpenTesti={setOpenTesti}
                              setTestimoniItem={setTestimoniItem}
                              testimoniItem={testimoniItem}
                              data={item}
                              key={index}
                              getTestimonials={(scheduleId) => {
                                props.history.push(
                                  `/e/${eventCode}/schedule/${scheduleId}`
                                );
                              }}
                            />
                          ))}
                        {audioId !== null && (
                          <div style={{ marginBottom: 150 }} />
                        )}
                      </div>
                    )}
                  </React.Fragment>
                }
                rightChildren={
                  <React.Fragment>
                    <div
                      id={"typeforms"}
                      style={{
                        position: "absolute",
                        top: "0px",
                        visibilty: "hidden",
                      }}
                    ></div>
                    <p className="text-wantask" style={{ display: "none" }}>
                      Ajukan Pertanyaan
                    </p>
                    <div className="desktops">
                      <div className="want-ask" style={{ display: "none" }}>
                        <div>
                          <img src="/assets/images/e_ask.svg" alt="e_ask" />
                          <h4>
                            Mau bertanya ke narasumber? Gak perlu nunggu
                            webinar!
                          </h4>
                        </div>
                        <button onClick={gotoTypeForm}>
                          Kirim Pertanyaan Sekarang Juga
                        </button>
                      </div>

                      {dataRightAds &&
                        dataRightAds[0]?.adsType === "right-sidebar" && (
                          <div
                            className="lists"
                            style={{ marginBottom: "20px" }}
                          >
                            <CardAds
                              getAdvertisingLog={() => undefined}
                              eventCode={eventCode}
                              data={dataRightAds[0]}
                            />
                          </div>
                        )}
                    </div>
                    {!isMobile && <CallCenter />}
                  </React.Fragment>
                }
              />
            </div>
          </div>
        </>
      )}
      {openLogin && (
        <PopupAuthEvent
          setOpenLogin={setOpenLogin}
          tenantId={eventData?.tenantId}
          eventCode={eventCode}
          idl={idl}
          setIdl={setIdl}
        />
      )}

      {askQuestion && (
        <AskQuestionContainer
          question={question}
          eventData={eventData}
          setAskQuestion={setAskQuestion}
          isQuestionSubmitted={isQuestionSubmitted}
          setIsQuestionSubmitted={setIsQuestionSubmitted}
          profile={profile}
          speaker={speaker}
          setIsValid={setIsValid}
          setIsWAEmpty={setIsWAEmpty}
        >
          {!isQuestionSubmitted ? (
            <FillQna
              qna={question}
              isImportant={true}
              setQna={setQuestion}
              eventData={eventData}
              profileRules={eventData ? JSON.parse(eventData.rules) : {}}
              qnaFormStatus={undefined}
              setProfile={setProfile}
              profile={profile}
              profileMember={profileMember}
              isValid={isValid}
              isWAEmpty={isWAEmpty}
            />
          ) : (
            <div className="q_submitted">
              <img src="/assets/images/u_check-circle.svg" />
              <div>
                Pertanyaan Kamu
                <br />
                Berhasil Dikirim
              </div>
            </div>
          )}
        </AskQuestionContainer>
      )}
      {audioId !== null && (
        <PopupAudioEvent
          isNewLayout
          titleAudio={titleAudio}
          audioId={audioId}
          setAudioId={setAudioId}
        />
      )}
      {openTesti && (
        <PopupTesti
          data={testimoniItem}
          close={() => {
            setOpenTesti(false);
          }}
          send={sendTesti}
          loading={testimonLoading}
          changeReason={(reason) =>
            setTestimoniItem({ ...testimoniItem, reason })
          }
          changeRate={(score) => {
            setTestimoniItem({ ...testimoniItem, score });
          }}
        />
      )}

      {premiumDialog && (
        <PremiumDialog
          endDate={eventData?.endDate}
          onClose={() => setPremiumDialog(false)}
          expired={expired}
          history={props.history}
          eventCode={eventCode.replace("/", "")}
        />
      )}
    </React.Fragment>
  );
}

export default withRouter(WebinarHome);
